import React from "react";
import { Box, Button, Flex, Heading, Text, Badge, useColorModeValue } from "@chakra-ui/react";
import { CiCalendar, CiLocationOn, CiUser, CiCoins1, CiRollingSuitcase } from "react-icons/ci";
import { Candidature } from "./CandidatureService";
import { Mission } from "../mission/MissionService";

interface CandidatureCardProps {
    candidature: Candidature & { mission?: Mission };
}

const CandidatureCard: React.FC<CandidatureCardProps> = ({ candidature }) => {
    const cardBg = useColorModeValue('white', 'gray.800');
    const accentColor = "#420073";
    const hoverShadow = useColorModeValue('lg', 'dark-lg');

    const statusColor = {
        "ACCEPTED": "green",
        "REJECTED": "red",
        "PENDING": "yellow",
        "BROUILLON": "gray"
    };

    const formatDate = (dateArray: number[]) => {
        if (!dateArray || dateArray.length < 3) return "Date non disponible";
        const [year, month, day, hour = 0, minute = 0] = dateArray;
        const date = new Date(Date.UTC(year, month - 1, day, hour, minute));

        return date.toLocaleDateString("fr-FR", {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    return (
        <Box
            p={5}
            mb={6}
            borderWidth="1px"
            borderRadius="lg"
            bg={cardBg}
            shadow="md"
            _hover={{
                shadow: hoverShadow,
                transform: 'translateY(-2px)',
            }}
            transition="all 0.2s"
        >
            <Flex justify="space-between" align="flex-start" mb={3}>
                <Heading fontSize="xl" color={accentColor}>
                    {candidature.mission?.opportunite || "Mission non disponible"}
                </Heading>


            </Flex>

            {candidature.mission && (
                <Flex direction="column" gap={2} mb={4}>
                    <Flex align="center">
                        <CiCoins1 size={18} color={accentColor} />
                        <Text ml={2} fontSize="sm">{candidature.mission.compte}</Text>
                    </Flex>

                    <Flex align="center">
                        <CiRollingSuitcase size={18} color={accentColor} />
                        <Text ml={2} fontSize="sm">{candidature.mission.metier}</Text>
                        <Badge ml={2} colorScheme="purple">{candidature.mission.domaine}</Badge>
                    </Flex>

                    <Flex align="center">
                        <CiLocationOn size={18} color={accentColor} />
                        <Text ml={2} fontSize="sm">{candidature.mission.localisation}</Text>
                    </Flex>

                    <Flex align="center">
                        <CiUser size={18} color={accentColor} />
                        <Text ml={2} fontSize="sm">{candidature.mission.manager}</Text>
                    </Flex>
                </Flex>
            )}

            <Flex align="center" justify="space-between">
                <Flex align="center">
                    <CiCalendar size={18} color={accentColor} />
                    <Text ml={2} fontSize="sm">
                        Candidature du {formatDate(candidature.publicationDate)}
                    </Text>
                </Flex>

            </Flex>
        </Box>
    );
};

export default CandidatureCard;